import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";

import { hasAdminAccess } from "../../../helpers/roles";
import secureLocalStorage from "react-secure-storage";

/**
 * @component OverviewTabs
 * this component will display three tabs
 * and you can press on them and it will show different results
 * 
 * @param {function} t
 * @param {function} handleChangeTab
 * @returns {JSX.Element} Overview Tabs Component
 */
export default function OverviewTabs({ t, handleChangeTab }) {
  const storedUser = secureLocalStorage.getItem("userInfo");
  const user = JSON.parse(storedUser);
  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <TabList onChange={handleChangeTab} aria-label="ingredients tabs">
        <Tab label={t("dashboard.tabs.tab1")} value="1" />
        <Tab label={t("dashboard.tabs.tab2")} value="2" />
        <Tab label={t("dashboard.tabs.tab4")} value="4" />

        {/* 2. SAFE ACCESS: Ensures user exists before hasAdminAccess tries to check it */}
        {user && hasAdminAccess(user) && (
          <Tab label={t("dashboard.tabs.tab3")} value="3" />
        )}
      </TabList>
    </Box>
  );
}